import { AmplitudeHelper, AsyncLib } from "@wisr/common";

import { isBrowser } from "../gatsby.utils";
import { QUOTE_APPLICATION } from "./analytics.constants";

/* istanbul ignore next */
/* eslint-disable @typescript-eslint/no-explicit-any */
const scope: Window = isBrowser() ? window : ({} as any);
export const quoteAmplitudeHelper = new AmplitudeHelper(QUOTE_APPLICATION);
export const datalayerHelper = new AsyncLib("dataLayer", scope);
export const googleAnalyticsHelper = new AsyncLib("ga", scope, {
  customTest: (ga) => !!ga.getAll,
});
export const hotjarHelper = new AsyncLib("hj", scope);

export function sendGtmEvent<E extends { [key: string]: unknown }>(event: E) {
  if (isBrowser()) {
    return datalayerHelper.get().then((datalayer) => {
      datalayer.push(event);
    });
  }
  return Promise.resolve();
}

export function gtmConversion(
  userType: string,
  loanId: number,
  aggregatorId: string | null,
  loanAmount: number,
  loanReason: string
) {
  return sendGtmEvent({
    event: "GTMAppSubmitted",
    loanId: loanId,
    userType: userType,
    aggregatorId: aggregatorId,
    loanAmount: loanAmount,
    loanReason: loanReason,
  });
}

export function gtmEcommerce(
  loanId: number,
  aggregatorName: string | null,
  loanAmount: number,
  loanReason: string,
  loanType: string
) {
  return sendGtmEvent({
    event: "GTMAppFormTransaction",
    eventCategory: "ecommerce",
    eventAction: "purchase",
    ecommerce: {
      purchase: {
        actionField: {
          id: loanId, //transaction ID - mandatory
          affiliation: aggregatorName ? "wisr - " + aggregatorName : "wisr",
          revenue: loanAmount, //total including tax and shipping
          tax: 0,
          shipping: 0,
        },
        products: [
          {
            id: loanId, //transaction ID - mandatory
            name: loanReason,
            category: loanType,
            price: loanAmount,
            quantity: 1,
          },
        ],
      },
    },
  });
}

export function sendGaEvent(
  category: string,
  action: string,
  label?: string,
  value?: number
) {
  if (isBrowser()) {
    return googleAnalyticsHelper.get().then((ga) => {
      const tracker = ga.getAll()[0];
      if (tracker) {
        const trackerName = tracker.get("name");
        ga(`${trackerName}.send`, "event", category, action, label, value);
      }
    });
  }
  return Promise.resolve();
}

type HotjarUserAttributes = { [k: string]: string | null | number };
export function hotjarIdentify(
  userId: string,
  attributes?: HotjarUserAttributes
) {
  return hotjarHelper.get().then((hotjar) => {
    hotjar("identify", userId, attributes);
  });
}
